// is this the right way to export an object?
export { default as masterMap } from "./createMaps";
